import Vue from 'vue';
import { Message  } from 'view-design';


Vue.prototype.$message = Message;

Vue.prototype.$message.config({
  duration: 3
});
